import { GeneralBookingModel, SlotBookingModel } from "../../Model/index";
export class BookingDoctorDataContainer {

    generalBooking: GeneralBookingModel;
    slotBooking: SlotBookingModel;
    bookingMode: string;  

   
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./app/Model/booking/bookingdoctordatacontainer.ts